import { RefObject } from "react";
import { IAnalyticsDataItem } from "../types";
import CustomPie from "./Pie";
import { useTranslation } from "react-i18next";
import AnalitycsItemList from "./AnalyticsItemList";
import { useAnalyticsData } from "./useAnalyticsData";

interface ITimePie {
	data: IAnalyticsDataItem[] | null
	is: "projects" | "employees" | "categories" | "employees_names"
	pieRef: RefObject<HTMLDivElement>
}

export default function TimePie({ data, pieRef, is } : ITimePie) {

	const { t } = useTranslation();
	const { globalAnalyticsData } = useAnalyticsData();

	const isString = 
	is === "projects" ? 
	"employees" : 
	is === "employees" ? 
	"projects" :
	is === "categories" ?
	"categories" :
	"employees";

	return (
		<div className="analytics-item__block">
			<div className="analytics-item__block-name">
				<b>{t("analytics_page.pie.time_statistic")}</b>
			</div>
			<div className="analytics-item__block-row">
				<div className="analytics-item__chart" style={{ width: "220px", height: "220px" }}>
					<CustomPie data={data} total="time" pieRef={pieRef} />
				</div>
				<div className="analytics-item__legend">
				<h3 className="analytics-item__legend-title">{t(`analytics_page.is.${isString}`)} ({data ? data.length : 0}):</h3>

					<AnalitycsItemList data={data} by="time" isCategories={is === "categories"} />
				</div>
			</div>
		</div>
	)
}